import ListTemplate from 'components/template/ListTemplate';
import Button from 'components/atom/Button';

import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryFilterTaxas } from './hooks/useQueryFilterTaxas';
import { useHeaderTaxas } from './hooks/useHeaderTaxas';
import { useQueryPermissions } from 'pages/coleta/listar/hooks/useQueryPermissions';
import { useTransformTaxas } from './hooks/useTransformTaxas';

const PageListTaxas: FC<any> = () => {
    const history = useHistory();
    const props = useQueryFilterTaxas();

    const permissions = useQueryPermissions();
    const colunas = useHeaderTaxas(permissions);
    const data = useTransformTaxas(props, permissions);

    const handleCreateNew = () => {
        history.push('/admin/taxas/create-taxa');
    };

    return (
        <ListTemplate
            browserTitle="Taxas"
            colunas={colunas}
            data={data}
            floatingActionButton={
                <button
                    onClick={handleCreateNew}
                    style={{
                        width: '4.5rem',
                        height: '4.5rem',
                        borderRadius: '50%',
                        backgroundColor: '#0056b3',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '1.5rem',
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                        transition: 'all 0.2s ease'
                    }}
                    title="Criar Nova Taxa"
                >
                    +
                </button>
            }
            {...props}
        />
    );
};

export default PageListTaxas;